import { render, staticRenderFns } from "./ModalProductSettings.vue?vue&type=template&id=6b2086c9&scoped=true"
import script from "./ModalProductSettings.vue?vue&type=script&lang=js"
export * from "./ModalProductSettings.vue?vue&type=script&lang=js"
import style0 from "./ModalProductSettings.vue?vue&type=style&index=0&id=6b2086c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2086c9",
  null
  
)

export default component.exports